module.exports = __webpack_public_path__ + "static/media/rdbu.dabbd260.jpg";